import React from 'react';
import styles from './Escolhaestabelecimento.module.css';
import logo from '../../../images/novalogo_speedorder.png';

// ============================================================
// Dados das opções — mova para fora do componente ou para uma
// config separada se precisar reaproveitar em outro lugar
// (ex: painel de "adicionar novo estabelecimento" depois do login).
// ============================================================
const OPCOES = [
  {
    id: 'unieat',
    href: '/cadastroadmin',
    emoji: '🎓',
    titulo: 'Lanchonete Universitária',
    subtitulo: 'Módulo UniEat',
  },
  {
    id: 'eatorder',
    href: '/cadastroadmin',
    emoji: '🍽',
    titulo: 'Restaurante',
    subtitulo: 'Módulo EatOrder',
  },
];

function ArrowIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true">
      <path
        d="M7 4l6 6-6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function BackIcon() {
  return (
    <svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true">
      <path
        d="M13 4l-6 6 6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function EscolhaEstabelecimento() {
  return (
    <div className={styles.screen}>
      <div className={styles.card}>

        <img src={logo} alt="SpeedOrder" className={styles.logo} />

        <div className={styles.dots} aria-hidden="true">
          <span className={`${styles.dot} ${styles.dotActive}`} />
          <span className={styles.dot} />
        </div>

        <h1 className={styles.title}>Qual é o tipo do seu estabelecimento?</h1>
        <p className={styles.subtitle}>
          Isso define o app que você vai usar pra gerenciar seu negócio.
        </p>

        <div className={styles.optionsList} role="group" aria-label="Tipo de estabelecimento">
          {OPCOES.map((opcao) => (
            <a
              key={opcao.id}
              href={opcao.href}
              className={styles.optionRow}
              onClick={() => localStorage.setItem('tipo_estabelecimento', opcao.id)}
            >
              <span className={styles.optionIcon} aria-hidden="true">
                {opcao.emoji}
              </span>
              <span className={styles.optionText}>
                <strong>{opcao.titulo}</strong>
                <span>{opcao.subtitulo}</span>
              </span>
              <span className={styles.optionArrow}>
                <ArrowIcon />
              </span>
            </a>
          ))}
        </div>

        <p className={styles.help}>
          Não sabe qual escolher?{' '}
          <a href="https://www.speedorder.com.br#contato">Fale com a gente</a>
        </p>
      </div>
    </div>
  );
}